export const bpInfo = {version: 'v1.6.29'};
